import { EmptyProps } from "./BaseReactComponent";

class Empty extends React.Component<EmptyProps, never> {
    public render(): JSX.Element {
        var displayString: string = "";

        if (sessionStore.userLanguageCode.toLowerCase() == "fr")
            displayString = "À venir";
        else if (sessionStore.userLanguageCode.toLowerCase().replace("-", "") == "esmx")
            displayString = "Próximamente";
        else
            displayString = "Coming Soon";

        return (
            <div className="workspace">
                <div className="myle-page-header bottom-border">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <p className="header-font-color">module</p>
                            <h3 className="thin-font">{displayString}</h3>
                        </div>
                    </div>
                </div>
                <div className="ws-footer" />
            </div>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }
}

export { Empty };
